import React, { useEffect, useState } from "react";

import { getApiBase } from "../../views/store-evaluations/storeEvaluationsApi";

const normalizeBearer = (token: string): string => {
  const t = String(token ?? "").trim();
  return t.toLowerCase().startsWith("bearer ") ? t.slice(7).trim() : t;
};

const getImageUrl = (assetId: string) => `${getApiBase()}/uploads/images/${encodeURIComponent(assetId)}`;

// GET /uploads/images/:assetId exige JWT — <img src> não envia Authorization,
// então buscamos via fetch autenticado e exibimos como object URL.
const AuthImage: React.FC<{
  token: string;
  assetId: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  /** Classe do texto de carregando/erro (padrão: a da tela antiga do supervisor). */
  statusClassName?: string;
}> = ({ token, assetId, alt, className, style, statusClassName = "ListItemSub" }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(getImageUrl(assetId), {
          headers: { Authorization: `Bearer ${normalizeBearer(token)}` },
        });
        if (!res.ok) throw new Error();
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [token, assetId]);

  if (failed) return <div className={statusClassName}>Não foi possível carregar a imagem.</div>;
  if (!src) return <div className={statusClassName}>Carregando imagem...</div>;
  return <img src={src} alt={alt} className={className} style={style} />;
};

export default AuthImage;
